import { ModuleWithProviders, NgModule } from '@angular/core';
import {NgTicketsConfig, NgTicketsConfigService} from '../../services/config.service';

@NgModule({
  declarations: [],
  imports: [ ],
  exports: [ ]
})
export class NgTicketsModule {
  static forRoot(config: NgTicketsConfig): ModuleWithProviders {
    return {
      ngModule: NgTicketsModule,
      providers: [
        { provide: NgTicketsConfigService, useValue: config }
      ]
    };
  }

  static forChild(): ModuleWithProviders {
    return {
      ngModule: NgTicketsModule
    };
  }
}
